export default [
  {
    name: 'topup_goods_manage',
    path: 'topup_goods_manage',
    component: () =>
      import(/* webpackChunkName: "mobileTopup" */ './GoodsManagement.vue')
  }
]
